import { useQuery } from '@tanstack/react-query'

import { Logger } from '@core/logger'
import { SubscriptionQueryKey } from '../helpers/queryKeys'

import { getBillingProducts } from '../services/getBillingProducts'

export const useGetBillingProducts = (products: string[]) => {
    return useQuery({
        queryKey: SubscriptionQueryKey.billingProducts(products),
        enabled: Boolean(products.length),
        queryFn: async ({ signal }) => {
            try {
                return await getBillingProducts({ signal, products })
            } catch (error) {
                if (!signal.aborted) {
                    Logger.error('Failed to fetch billing products', { error, products })
                }

                throw error
            }
        },
    })
}
